import React from 'react';

import './PrivacyDeposit.css';

function PrivacyDeposit(props) {

    const [amount, setAmount] = React.useState("");

    const changeAmount = (val) => {
        val = val.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
        setAmount(val);
    }

    return (
        <div className="ghost-privacy-transfer-container">
            <div className="ghost-privacy-transfer-header">
                <div className="ghost-privacy-transfer-header-container">
                    <div className="ghost-privacy-transfer-header-container-title">Deposit Funds</div>
                    <div className="ghost-privacy-transfer-header-container-text">Wrap you {props.asset === "STRL" ? "GHST" : props.asset.slice(1)} to {props.asset}.</div>
                </div>

                <div className="ghost-privacy-transfer-balance">
                    <div className="ghost-privacy-transfer-balance-title">Balance</div>
                    <div className="ghost-privacy-transfer-balance-amount">3.2347 {props.asset}</div>
                </div>

            </div>
	    
	    <div className="ghost-privacy-interaction-converter">In order to make your balance not linkable, convert your {props.asset === "STRL" ? "GHST" : props.asset.slice(1)} to {props.asset} on fixed rate that is stable and forever: <b>1:100</b>. Depends only on `decimals` of the token</div>

            <div className="ghost-privacy-transfer-main">
                <div className="ghost-privacy-transfer-main-receiver">
                    <input spellCheck="false" onChange={(val) => changeAmount(val.target.value)}  value={amount} type="text" placeholder="Amount to be deposit"></input>
                </div>
            </div>
            <div className="ghost-propose-claim-buttons ghost-privacy-button-transfer">
                <div onClick={() => {alert("transfered")}} className="ghost-propose-claim-buttons-button ghost-privacy-button-transfer-adapt">Deposit</div>
            </div>

        </div>
    )

}

export default PrivacyDeposit;
